export const NS_SET_RUN_INSTANCE_CONFIG = 'NS_SET_RUN_INSTANCE_CONFIG';
export const NS_GET_RUN_INSTANCE_RESULT_LIST =
  'NS_SET_GET_RUN_INSTANCE_RESULT_LIST';
export const NS_GET_RUN_INSTANCE_RESULT_LIST_SUCCESS =
  'NS_GET_RUN_INSTANCE_RESULT_LIST_SUCCESS';
export const NS_GET_RUN_INSTANCE_RESULT_LIST_FAIL =
  'NS_GET_RUN_INSTANCE_RESULT_LIST_FAIL';
export const NS_GET_RUN_INSTANCE_SUMMARY = 'NS_GET_RUN_INSTANCE_SUMMARY';
export const NS_GET_RUN_INSTANCE_SUMMARY_SUCCESS =
  'NS_GET_RUN_INSTANCE_SUMMARY_SUCCESS';
export const NS_GET_RUN_INSTANCE_SUMMARY_FAIL =
  'NS_GET_RUN_INSTANCE_SUMMARY_FAIL';
export const NS_GET_RUN_INSTANCE_WATCHLIST_INITIATE =
  'NS_GET_RUN_INSTANCE_WATCHLIST_INITIATE';
export const NS_GET_RUN_INSTANCE_WATCHLIST_SUCCESS =
  'NS_GET_RUN_INSTANCE_WATCHLIST_SUCCESS';
export const NS_GET_RUN_INSTANCE_WATCHLIST_FAIL =
  'NS_GET_RUN_INSTANCE_WATCHLIST_FAIL';
export const NS_GET_RUN_INSTANCE_WATCHLIST_COVERAGE_REPORTS_INITIATE =
  'NS_GET_RUN_INSTANCE_WATCHLIST_COVERAGE_REPORTS_INITIATE';
export const NS_GET_RUN_INSTANCE_WATCHLIST_COVERAGE_REPORTS_SUCCESS =
  'NS_GET_RUN_INSTANCE_WATCHLIST_COVERAGE_REPORTS_SUCCESS';
export const NS_GET_RUN_INSTANCE_WATCHLIST_COVERAGE_REPORTS_FAIL =
  'NS_GET_RUN_INSTANCE_WATCHLIST_COVERAGE_REPORTS_FAIL';
export const NS_GET_RUN_INSTANCE_WHITELIST_INITIATE =
  'NS_GET_RUN_INSTANCE_WHITELIST_INITIATE';
export const NS_GET_RUN_INSTANCE_WHITELIST_SUCCESS =
  'NS_GET_RUN_INSTANCE_WHITELIST_SUCCESS';
export const NS_GET_RUN_INSTANCE_WHITELIST_FAIL =
  'NS_GET_RUN_INSTANCE_WHITELIST_FAIL';
export const NS_GET_ALERT_DETAILS_LIST_DATA = 'NS_GET_ALERT_DETAILS_LIST_DATA';
export const NS_GET_ALERT_DETAILS_LIST_DATA_SUCCESS =
  'NS_GET_ALERT_DETAILS_LIST_DATA_SUCCESS';
export const NS_GET_ALERT_DETAILS_LIST_DATA_FAIL =
  'NS_GET_ALERT_DETAILS_LIST_DATA_FAIL';
export const NS_POST_HITS_USER_FEEDBACK = 'NS_POST_HITS_USER_FEEDBACK';
export const NS_POST_HITS_USER_FEEDBACK_SUCCESS =
  'NS_POST_HITS_USER_FEEDBACK_SUCCESS';
export const NS_POST_HITS_USER_FEEDBACK_FAIL =
  'NS_POST_HITS_USER_FEEDBACK_FAIL';
export const NS_POST_DEPLOY_TO_PRODUCTION = 'NS_POST_DEPLOY_TO_PRODUCTION';
export const NS_POST_DEPLOY_TO_PRODUCTION_SUCCESS =
  'NS_POST_DEPLOY_TO_PRODUCTION_SUCCESS';
export const NS_POST_DEPLOY_TO_PRODUCTION_FAIL =
  'NS_POST_DEPLOY_TO_PRODUCTION_FAIL';

export const NS_SAVE_RUN_INSTANCE = 'NS_SAVE_RUN_INSTANCE';
export const NS_SAVE_RUN_INSTANCE_SUCCESS = 'NS_SAVE_RUN_INSTANCE_SUCCESS';
export const NS_SAVE_RUN_INSTANCE_FAIL = 'NS_SAVE_RUN_INSTANCE_FAIL';
export const NS_POST_RUN_RUN_INSTANCE = 'NS_POST_RUN_RUN_INSTANCE';
export const NS_POST_RUN_RUN_INSTANCE_SUCCESS =
  'NS_POST_RUN_RUN_INSTANCE_SUCCESS';
export const NS_POST_RUN_RUN_INSTANCE_FAIL = 'NS_POST_RUN_RUN_INSTANCE_FAIL';

export const NS_GET_RUN_INSTANCE_VIEW_EXECUTION =
  'NS_GET_RUN_INSTANCE_VIEW_EXECUTION';
export const NS_GET_RUN_INSTANCE_VIEW_EXECUTION_SUCCESS =
  'NS_GET_RUN_INSTANCE_VIEW_EXECUTION_SUCCESS';
export const NS_GET_RUN_INSTANCE_VIEW_EXECUTION_FAIL =
  'NS_GET_RUN_INSTANCE_VIEW_EXECUTION_FAIL';

export const NS_GET_CUSTOMER_TYPE = 'NS_GET_CUSTOMER_TYPE';
export const NS_GET_CUSTOMER_TYPE_SUCCESS = 'NS_GET_CUSTOMER_TYPE_SUCCESS';
export const NS_GET_CUSTOMER_TYPE_FAIL = 'NS_GET_CUSTOMER_TYPE_FAIL';

export const NS_POST_CUSTOMER_TYPE = 'NS_POST_CUSTOMER_TYPE';
export const NS_POST_CUSTOMER_TYPE_SUCCESS = 'NS_POST_CUSTOMER_TYPE_SUCCESS';
export const NS_POST_CUSTOMER_TYPE_FAIL = 'NS_POST_CUSTOMER_TYPE_FAIL';

export const NS_PUT_CUSTOMER_TYPE = 'NS_PUT_CUSTOMER_TYPE';
export const NS_PUT_CUSTOMER_TYPE_SUCCESS = 'NS_PUT_CUSTOMER_TYPE_SUCCESS';
export const NS_PUT_CUSTOMER_TYPE_FAIL = 'NS_PUT_CUSTOMER_TYPE_FAIL';

export const NS_DELETE_CUSTOMER_TYPE = 'NS_DELETE_CUSTOMER_TYPE';
export const NS_DELETE_CUSTOMER_TYPE_SUCCESS =
  'NS_DELETE_CUSTOMER_TYPE_SUCCESS';
export const NS_DELETE_CUSTOMER_TYPE_FAIL = 'NS_DELETE_CUSTOMER_TYPE_FAIL';

export function configRunInstance(payload) {
  return {
    type: NS_SET_RUN_INSTANCE_CONFIG,
    payload
  };
}

/**
 * Alert Details
 **/
export const getNSAlertDetailsListData = (payload) => {
  return {
    type: NS_GET_ALERT_DETAILS_LIST_DATA,
    payload
  };
};

export const getNSAlertDetailsListDataSuccess = (payload) => {
  return {
    type: NS_GET_ALERT_DETAILS_LIST_DATA_SUCCESS,
    payload
  };
};

export const getNSAlertDetailsListDataFail = (payload) => {
  return {
    type: NS_GET_ALERT_DETAILS_LIST_DATA_FAIL,
    payload
  };
};

/**
 * Run Instance List
 **/
export function getNSRunInstanceResultListData(payload) {
  return {
    type: NS_GET_RUN_INSTANCE_RESULT_LIST,
    payload
  };
}

export const getNSRunInstanceResultListDataSuccess = (payload) => {
  return {
    type: NS_GET_RUN_INSTANCE_RESULT_LIST_SUCCESS,
    payload
  };
};

export const getNSRunInstanceResultListDataFail = (payload) => {
  return {
    type: NS_GET_RUN_INSTANCE_RESULT_LIST_FAIL,
    payload
  };
};

/***
 * Run Instance Summary
 ***/
export const getNSRunInstanceSummaryData = (payload) => {
  return {
    type: NS_GET_RUN_INSTANCE_SUMMARY,
    payload
  };
};

export const getNSRunInstanceSummaryDataSuccess = (payload) => {
  return {
    type: NS_GET_RUN_INSTANCE_SUMMARY_SUCCESS,
    payload
  };
};

export const getNSRunInstanceSummaryDataFail = (payload) => {
  return {
    type: NS_GET_RUN_INSTANCE_SUMMARY_FAIL,
    payload
  };
};

/**
 *  Hits UserFeedback
 **/
export function postNSHitsUserFeedback(payload) {
  return {
    type: NS_POST_HITS_USER_FEEDBACK,
    payload
  };
}

export function postNSHitsUserFeedbackSuccess(payload) {
  return {
    type: NS_POST_HITS_USER_FEEDBACK_SUCCESS,
    payload
  };
}

export function postNSHitsUserFeedbackFail(payload) {
  return {
    type: NS_POST_HITS_USER_FEEDBACK_FAIL,
    payload
  };
}

/**
 *  WatchList actions
 **/
export function getNSRIWatchListInitiate(payload) {
  return {
    type: NS_GET_RUN_INSTANCE_WATCHLIST_INITIATE,
    payload
  };
}

export const getNSRIWatchListSuccess = (payload) => {
  return {
    type: NS_GET_RUN_INSTANCE_WATCHLIST_SUCCESS,
    payload
  };
};

export const getNSRIWatchListFail = (payload) => {
  return {
    type: NS_GET_RUN_INSTANCE_WATCHLIST_FAIL,
    payload
  };
};

export function getNSRIWatchListCoverageReportsInitiate(payload) {
  return {
    type: NS_GET_RUN_INSTANCE_WATCHLIST_COVERAGE_REPORTS_INITIATE,
    payload
  };
}

export const getNSRIWatchListCoverageReportsSuccess = (payload) => {
  return {
    type: NS_GET_RUN_INSTANCE_WATCHLIST_COVERAGE_REPORTS_SUCCESS,
    payload
  };
};

export const getNSRIWatchListCoverageReportsFail = (payload) => {
  return {
    type: NS_GET_RUN_INSTANCE_WATCHLIST_COVERAGE_REPORTS_FAIL,
    payload
  };
};

/**
 *  WhiteList actions
 **/
export function getNSRIWhiteListInitiate(payload) {
  return {
    type: NS_GET_RUN_INSTANCE_WHITELIST_INITIATE,
    payload
  };
}

export const getNSRIWhiteListSuccess = (payload) => {
  return {
    type: NS_GET_RUN_INSTANCE_WHITELIST_SUCCESS,
    payload
  };
};

export const getNSRIWhiteListFail = (payload) => {
  return {
    type: NS_GET_RUN_INSTANCE_WHITELIST_FAIL,
    payload
  };
};

/**
 *  Deploy To Production
 **/
export function postDeployToProduction(payload) {
  return {
    type: NS_POST_DEPLOY_TO_PRODUCTION,
    payload
  };
}

export const postDeployToProductionSuccess = (payload) => {
  return {
    type: NS_POST_DEPLOY_TO_PRODUCTION_SUCCESS,
    payload
  };
};

export const postDeployToProductionFail = (payload) => {
  return {
    type: NS_POST_DEPLOY_TO_PRODUCTION_FAIL,
    payload
  };
};

/**
 *  Save run instance matching config actions
 **/
export function saveNSRunInstance(payload) {
  return {
    type: NS_SAVE_RUN_INSTANCE,
    payload
  };
}

export const saveNSRunInstanceSuccess = (payload) => {
  return {
    type: NS_SAVE_RUN_INSTANCE_SUCCESS,
    payload
  };
};

export const saveNSRunInstanceFail = (payload) => {
  return {
    type: NS_SAVE_RUN_INSTANCE_FAIL,
    payload
  };
};

/**
 *  Save & run the Run Instance
 **/
export function postRunRunInstance(payload) {
  return {
    type: NS_POST_RUN_RUN_INSTANCE,
    payload
  };
}

export const postRunRunInstanceSuccess = (payload) => {
  return {
    type: NS_POST_RUN_RUN_INSTANCE_SUCCESS,
    payload
  };
};

export const postRunRunInstanceFail = (payload) => {
  return {
    type: NS_POST_RUN_RUN_INSTANCE_FAIL,
    payload
  };
};

/**
 * Run Instance - view executions
 **/
export function getRunInstanceViewExecution(payload) {
  return {
    type: NS_GET_RUN_INSTANCE_VIEW_EXECUTION,
    payload
  };
}

export const getRunInstanceViewExecutionSuccess = (payload) => {
  return {
    type: NS_GET_RUN_INSTANCE_VIEW_EXECUTION_SUCCESS,
    payload
  };
};

export const getRunInstanceViewExecutionFail = (payload) => {
  return {
    type: NS_GET_RUN_INSTANCE_VIEW_EXECUTION_FAIL,
    payload
  };
};

/**
 * GET Customer Type
 **/
export const getCustomerType = (payload) => {
  return {
    type: NS_GET_CUSTOMER_TYPE,
    payload
  };
};

export const getCustomerTypeSuccess = (payload) => {
  return {
    type: NS_GET_CUSTOMER_TYPE_SUCCESS,
    payload
  };
};

export const getCustomerTypeFail = (payload) => {
  return {
    type: NS_GET_CUSTOMER_TYPE_FAIL,
    payload
  };
};

/**
 * POST CUSTOMER TYPE
 */

export const postCustomerType = (payload) => {
  return {
    type: NS_POST_CUSTOMER_TYPE,
    payload
  };
};

export const postCustomerTypeSuccess = (payload) => {
  return {
    type: NS_POST_CUSTOMER_TYPE_SUCCESS,
    payload
  };
};

export const postCustomerTypeFail = (payload) => {
  return {
    type: NS_POST_CUSTOMER_TYPE_FAIL,
    payload
  };
};

/**
 * PUT CUSTOMER TYPE
 */

export const putCustomerType = (payload) => {
  return {
    type: NS_PUT_CUSTOMER_TYPE,
    payload
  };
};

export const putCustomerTypeSuccess = (payload) => {
  return {
    type: NS_PUT_CUSTOMER_TYPE_SUCCESS,
    payload
  };
};

export const putCustomerTypeFail = (payload) => {
  return {
    type: NS_PUT_CUSTOMER_TYPE_FAIL,
    payload
  };
};

/**
 * DELETE CUSTOMER TYPE
 */

export const deleteCustomerType = (payload) => {
  return {
    type: NS_DELETE_CUSTOMER_TYPE,
    payload
  };
};

export const deleteCustomerTypeSuccess = (payload) => {
  return {
    type: NS_DELETE_CUSTOMER_TYPE_SUCCESS,
    payload
  };
};

export const deleteCustomerTypeFail = (payload) => {
  return {
    type: NS_DELETE_CUSTOMER_TYPE_FAIL,
    payload
  };
};
